// eslint-disable-next-line import/no-anonymous-default-export
const config = {
  "us": {
    "chatServer": "wss://chat.fastballs.elbet.us:8765",
    "gameServers": ["https://server.fastballs.elbet.us:9334"]
  },
  "default": {
    "chatServer": "wss://chat.fastballs.elbet.com:8765",
    "gameServers": ["https://server.fastballs.elbet.com:9334"]
  }
}

export default config;